export default class PersonalityQuizParticipationBodyModel {
  public questionId: number = 0;
  public optionId: number = 0;
}
